import { z } from "zod";

const WaiverSubmissionSchema = z.object({
  email: z.string().email({ message: "Invalid email address" }),
  parentFirstName: z.string().min(1, { message: "First name is required" }),
  parentLastName: z.string().min(1, { message: "Last name is required" }),
  childFirstName: z.string().min(1, { message: "First name is required" }),
  childLastName: z.string().min(1, { message: "Last name is required" }),
  dateOfBirth: z.string().min(1, { message: "Date of birth is required" }),
  height: z.number().min(0, { message: "Height must be greater than 0" }),
  marketingConsent: z.boolean(),
  signatureDate: z.string().min(1, { message: "Signature date is required" }),
  signature: z.string().min(1, { message: "Signature is required" }),
  venueId: z.number(),
});

export type WaiverSubmission = z.infer<typeof WaiverSubmissionSchema>;

// Posts the signed waiver to spyops-core's /api/waiver/submit, which creates the child's
// event profile. This replaces a direct browser-to-SQS SendMessage that shipped a real AWS
// key in this bundle; the endpoint now does that work server-side. The bearer key below is
// still bundle-visible and is a tripwire, not a secret (see the endpoint's TSDoc).
export const submitWaiver = async (data: WaiverSubmission): Promise<void> => {
  WaiverSubmissionSchema.parse(data);

  const response = await fetch(process.env.REACT_APP_WAIVER_API_URL!, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${process.env.REACT_APP_WAIVER_API_KEY!}`,
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error(`Waiver submission failed: ${response.status}`);
  }
};
